import React, { useEffect, useState } from 'react';
import Axios from '../../lib/axios/axiosInstance';
import { Container, Row, Col, Form } from "react-bootstrap";
import "./HomeCategory.styles.css";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/logo.png";
import MobileMenu from "../../components/MobileMenu/MobileMenu";
import { Flip, Slide, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { userLogIn, isUserLogedIn } from "../../services/auth";
import { useNavigate } from 'react-router-dom';
import * as AuthVerify from '../../lib/common';
import { nextWednesday } from 'date-fns/esm';
import { forEach } from 'lodash';

const HomeCategory = ({ firstProp, secondProp, confirmPage }) => {
  const navigate = useNavigate();
  var key = 0;
  const [logedIn, setLogedIn] = useState(false);

  toast.configure();

  const [headerList, setHeaderList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [activeC, setActiveC] = useState(false);

  const getHeaders = async () => {
    try {
      await Axios.get('/sysvar/ProductType')
        .then(function (response) {
          if (response.data && response.data.ProductType) {
            if (response.data.ProductType.length > 0) {
              response.data.ProductType.forEach(element => {
                element.grp.newUrl = "/category?name=" + element.grp.url?.split("/")[1];
                if (element?.subgrp && element.subgrp.length > 0) {
                  element.subgrp.forEach(element2 => {
                    element2.grp.newUrl = "/category?name=" + element2.grp.url?.split("/")[1];
                    if (element2.subgrp?.length > 0) {
                      element2.subgrp.forEach(element3 => {
                        // element3.grp.newUrl="/category?name="+element3.grp.url?.split("/")[1]+"&baseName="+element3.grp.varname;
                        element3.grp.newUrl = "/category?name=" + element3.grp.url?.split("/")[1];
                      })
                    }
                  })
                }
              });
              setHeaderList(response.data.ProductType);
            }
            else {
              setHeaderList([]);
            }
          }
        })
        .catch(function (error) {
          setHeaderList([]);
        });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getHeaders();
    setLogedIn(AuthVerify.isUserLogedIn());
    return () => {
      // Cleanup function
      // Cancel any outstanding network requests or subscriptions here
    };
  }, [])

  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
    window.mobileMenuView();
  };

  return (
    <>
      <MobileMenu headerList={headerList} brand={brandList} collapsed={collapsed} activeC={activeC} />

      <div className="navigation" style={{ marginLeft: "15px" }}>
        {headerList.length > 0 &&
          // <ul className="childCustom" style={{left:'25%'}}>
          <ul>
            <li key={0} style={{ backgroundColor: "#666", color: "white", fontWeight: "bold", display: "grid", alignItems: "center", padding: "10px 20px" }}>CATEGORY</li>
            {headerList?.map((menu) => (
              <>
                {
                  <li key={key++}>
                    <Link to={menu.grp?.newUrl || '#'}><span className='parentName' style={{ display: 'table-cell !important' }}>{menu.grp.varname}</span></Link>
                    <ul>
                      {menu?.subgrp && menu?.subgrp.map((subMenu) => (
                        // <li style={{textAlign: 'left',fontWeight:'bold !important', borderBottom: '2px solid black', pointerEvents:'none'}}><a href="#">{subMenu.grp.varname}</a></li>
                        <>{subMenu.subgrp?.length > 0 ?
                          <>
                            <li key={key++}>
                              <Link to={subMenu.grp?.newUrl || '#'}><span className='parentName'>{subMenu.grp.varname}</span></Link>
                              <ul>
                                {subMenu?.subgrp?.map((subMenu2) => (
                                  <li key={key++}><Link to={subMenu2.grp?.newUrl || '#'}>{subMenu2.grp.varname}</Link></li>
                                ))
                                }
                              </ul>
                            </li>
                          </> :
                          <><li key={key++}><Link to={subMenu.grp?.newUrl || '#'}>{subMenu.grp.varname}</Link></li></>
                        }</>
                      ))}
                    </ul>
                  </li>
                }
              </>
            ))}
          </ul>
        }
        {headerList.length == 0 &&
          // <ul className="childCustom" style={{left:'25%'}}>
          <ul>
            <li key={0} style={{ backgroundColor: "#666", color: "white", fontWeight: "bold", display: "grid", alignItems: "center", padding: "10px 20px" }}>CATEGORY</li>
          </ul>
        }
      </div>

    </>
  );
};

export default HomeCategory;
